const FOLLOW = 'FOLLOW';
const UNFOLLOW = 'UNFOLLOW';
const SET_USERS = 'SET_USERS';


let initialState = {
    users: [
        {
            id: 1,
            name: "Tommy Shelby",
            location: "London, UK",
            friends: "547",
            followers: "678",
            followed: true,
            videos: "15",
            photos: "305",
            posts: "27",
            since: "January, 2019",
            imgURL: "https://i2-prod.liverpoolecho.co.uk/incoming/article23503282.ece/ALTERNATES/s1200c/1_Peaky-Blinders.jpg",
            bgURL: "https://c4.wallpaperflare.com/wallpaper/9/519/764/mountains-best-for-desktop-background-wallpaper-preview.jpg"
        },

        {
            id: 2,
            name: "Beth Harmon",
            location: "Kentucky, USA",
            friends: "145",
            followers: "513",
            followed: true,
            videos: "53",
            photos: "214",
            posts: "2",
            since: "November, 2021",
            imgURL: "https://wallpapers.com/images/high/the-queen-s-gambit-beth-digital-fan-art-mdazcu7vb7ga4sss.jpg",
            bgURL: "https://www.nasmeca.com/wp-content/uploads/2017/05/desktop-background-pictures-free-download-hd-wallpaper.jpg"
        },

        {
            id: 3,
            name: "Otis Milburn",
            location: "Moordale, UK",
            friends: "2252",
            followers: "98",
            followed: true,
            videos: "83",
            photos: "130",
            posts: "92",
            since: "September, 2016",
            imgURL: "https://i.pinimg.com/564x/7e/89/c5/7e89c51d342ef0f5fee570eb87165b55.jpg",
            bgURL: "https://images.template.net/wp-content/uploads/2014/09/Beautiful-Background-Wallpaper-Copy.jpg"
        },

        {
            id: 4,
            name: "Mike Wheeler",
            location: "City of Cabot, USA",
            friends: "89",
            followers: "6k",
            followed: true,
            videos: "47",
            photos: "305",
            posts: "27",
            since: "June, 1946",
            imgURL: "https://pbs.twimg.com/media/FEfNHs3VcA0IJnh.jpg",
            bgURL: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpFHcO9sDLc8nKhb8dEMHArb6VNJo0T20sZA&usqp=CAU"
        },

        {
            id: 5,
            name: "Emily Cooper",
            location: "Paris, France",
            friends: "2577",
            followers: "549",
            followed: true,
            videos: "1178",
            photos: "3205",
            posts: "2627",
            since: "March, 2020",
            imgURL: "https://pyxis.nymag.com/v1/imgs/720/78a/c64f539aa5d5cefac27ccd5b1b64e85a91-emily-in-paris.rsquare.w700.jpg",
            bgURL: "https://t3.ftcdn.net/jpg/03/02/83/02/360_F_302830255_ESzUQJqndMkqEW9h8puKmWoD0QTV1jJ6.jpg"
        },

        {
            id: 6,
            name: "Monica Geller",
            location: "New York, USA",
            friends: "479",
            followers: "405",
            followed: true,
            videos: "945",
            photos: "329",
            posts: "527",
            since: "May, 2001",
            imgURL: "https://blogscdn.thehut.net/app/uploads/sites/35/2020/04/everyfriendsoutfit5_1585754531.jpg",
            bgURL: "https://img.freepik.com/free-vector/flower-background-desktop-wallpaper-cute-vector_53876-136877.jpg"
        },

        {
            id: 7,
            name: "Michael Scott",
            location: "Scranton, USA",
            friends: "547",
            followers: "48k",
            followed: true,
            videos: "92",
            photos: "537",
            posts: "206",
            since: "April, 2013",
            imgURL: "http://cdn2.hubspot.net/hub/443262/file-2229220199-jpg/20110428_michaelscotttakesabow_photo_main_01.jpg",
            bgURL: "https://wallpaper.dog/large/985857.jpg"
        },

        {
            id: 8,
            name: "Meredith Grey",
            location: "Seattle, USA",
            friends: "1327",
            followers: "185",
            followed: true,
            videos: "23",
            photos: "305",
            posts: "27",
            since: "January, 2000",
            imgURL: "https://pm1.narvii.com/7611/fbbc085a8882aad21bac0d2ff868d05fefec504er1-750-687v2_hq.jpg",
            bgURL: "https://getwallpapers.com/wallpaper/full/0/d/7/282750.jpg"
        },

        {
            id: 9,
            name: "Sheldon Cooper",
            location: "Los Angeles, USA",
            friends: "549",
            followers: "5M",
            followed: true,
            videos: "45",
            photos: "305",
            posts: "27",
            since: "July, 2003",
            imgURL: "https://i.pinimg.com/280x280_RS/e7/0b/29/e70b29b882a77e6cc259801142c52e20.jpg",
            bgURL: "https://i.pinimg.com/originals/ce/ec/7a/ceec7ab306e1e234dc92d3d4e5f1a9e4.jpg"
        },
        {
            id: 10,
            name: "Harvey Specter",
            location: "Chicago, USA",
            friends: "91",
            followers: "936",
            followed: true,
            videos: "73",
            photos: "305",
            posts: "27",
            since: "August, 2009",
            imgURL: "https://heroandvillainstyle.com/wp-content/uploads/2020/06/harvey-specter-wardrobe-chalk-stripe-e1591562862946.jpg?ezimgfmt=rs:331x375/rscb4/ngcb4/notWebP",
            bgURL: "https://cdn.wallpapersafari.com/8/75/lVcy0n.jpg"
        },
        {
            id: 11,
            name: "Max Mayfield",
            location: "Hawkins, USA",
            friends: "691",
            followers: "629",
            followed: false,
            videos: "772",
            photos: "675",
            posts: "768",
            since: "April, 2002",
            imgURL: "https://i.pinimg.com/474x/cc/49/e2/cc49e28d907fbd7760e27a8e4142cd3d.jpg",
            bgURL: "http://wallup.net/wp-content/uploads/2016/01/36911-nature-trees-snow-mountain.jpg"
        },
        {
            id: 12,
            name: "Joey Tribbiani",
            location: "New York, USA",
            friends: "639",
            followers: "1893",
            followed: false,
            videos: "299",
            photos: "165",
            posts: "427",
            since: "July, 2022",
            imgURL: "https://i.pinimg.com/564x/57/95/2e/57952e4ce09b00127ad32ab6b6f0114d.jpg",
            bgURL: "https://images2.alphacoders.com/261/261330.jpg"
        }
    ]
};

const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FOLLOW:
            return {
                ...state,
                users: state.users.map(user => {
                    if (user.id === action.userId) {
                        return {...user, followed: false}
                    }
                    return user;
                })
            }
        case UNFOLLOW:
            return {
                ...state,
                users: state.users.map(user => {
                    if (user.id === action.userId) {
                        return {...user, followed: true}
                    }
                    return user;
                })
            }

        default:
            return state;
    }
}

export const followCreator = (userId) => {
    return {
        type: FOLLOW,
        userId
    }
}
export const unfollowCreator = (userId) => {
    return {
        type: UNFOLLOW,
        userId
    }
}
export const setUsersCreator = (users) => {
    return {
        type: SET_USERS,
        users
    }
}

export default usersReducer;
